import Route from 'cio/routes/requires-trigger-type-route';
import { queryConcat } from 'cio/helpers/query';
import { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import IndexController from './controller';
import Transition from '@ember/routing/-private/transition';
import CampaignModel from 'cio/models/campaign';

export default class IndexRoute extends Route {
  @service features!: FeaturesService;

  queryParams = {
    campaignStarted: {
      replace: true,
    },
  };

  templateName = 'base/setup/review/index';

  setupController(controller: IndexController, model: CampaignModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.campaignStarted = false;

    let { navSteps } = controller;

    controller.set('reviewSections', {
      triggerRecipients: navSteps.find((s) => ['trigger', 'recipients'].includes(s.name)),
      workflowSettings: navSteps.find((item) => item.name === 'settings'),
      workflow: navSteps.find((item) => item.name === 'workflow'),
      goal: navSteps.find((item) => item.name === 'goal'),
    });

    controller.customer.fetchRecipientCount.perform(queryConcat(model.anchors, model.filters, model.recipientsFilter));
    controller.fetchSegments.perform();
  }

  deactivate() {
    super.deactivate();
    this.rollbackModelFor();
  }
}
